import React, {  useEffect, useState } from 'react'
import { postUpdateUnResultadoProcedimiento } from '../../../services/Clinico'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; 

const ModalModificarUnResultadoProcedimiento = ({setmodalOnModificarResultadoProcedimiento, dataUnResultadoProcedimiento, setactualizarDataResultados}) => {
    //const [manejoInterfase, setmanejoInterfase]=useState('N')
    const [requiereManejoInterfase, setrequiereManejoInterfase]=useState('N')
    const [requiereTipoTransfusional, setrequiereTipoTransfusional]=useState('0')
    const [errorPalabraClave, seterrorPalabraClave]=useState('')
    const [errorDescripcion, seterrorDescripcion]=useState('')
    const [textDescripcion, settextDescripcion]=useState('')
    const [loading, setloading]=useState(true)
    const handleCancelarClick=()=>{
        setmodalOnModificarResultadoProcedimiento(false)
    }

    useEffect(()=>{
        setrequiereManejoInterfase(dataUnResultadoProcedimiento.RnqIndInt? dataUnResultadoProcedimiento.RnqIndInt: 'N')
        settextDescripcion(dataUnResultadoProcedimiento.RNQDes)
        setrequiereTipoTransfusional(dataUnResultadoProcedimiento.tipoTransfusional? dataUnResultadoProcedimiento.tipoTransfusional:'0')

    },[])

    const handleOnsubmitInsertResultadosProcedimientos=(e)=>{
        e.preventDefault()
        const modificarResultados={
                'RNQCod': e.target.codigo.value,
                'RNQClv': e.target.palabraClave.value,
                'RNQTip': e.target.tipoProcedimiento.value,
                'RNQTipG':'',
                'RNQDes': textDescripcion,
                'RNQLab':'',
                'RnqTipDie':'',
                'RnqVolMax':'',
                'RnqtmsMax':'',
                'RnqUndMed':'',
                'RnqIndInt': requiereManejoInterfase,
                'tipoTransfusional': requiereTipoTransfusional,
        }
        setloading(false)
        if(errorDescripcion === '' && errorPalabraClave === ''){  
            postUpdateUnResultadoProcedimiento(modificarResultados).then((res)=>{
                setloading(true)
                setactualizarDataResultados(modificarResultados)
                setmodalOnModificarResultadoProcedimiento(false)
            })
        }
        
    }

    const handleChangeManejoInterfase=()=>{
        const newValue = requiereManejoInterfase === "N" ? "S" : "N";
        setrequiereManejoInterfase(newValue)
    }

    const handleChangePalabraClave=(e)=>{
        if(e.target.value.trim()){
            seterrorPalabraClave('')
        }else{
            seterrorPalabraClave('Debe de diligenciar la palabra clave')
        }
    }

    const handleChangeDescripcion = (value) => {
      settextDescripcion(value);
      
      // Eliminamos etiquetas HTML y espacios en blanco
      const plainText = value.replace(/<\/?[^>]+(>|$)/g, "").trim();
  
      if (plainText) {
          seterrorDescripcion('');  // Si hay texto, eliminamos el error
      } else {
          seterrorDescripcion('Debe diligenciar la descripción');  // Si no hay texto, mostramos el error
      }
  };

  const handleChangeTipoTransfusional=()=>{
    const newValue = requiereTipoTransfusional === "0" ? "1" : "0";
    setrequiereTipoTransfusional(newValue)
  }
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-5xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">        
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     Modificar Resultados Procedimientos HC
    </h5>  
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative">
        <form onSubmit={handleOnsubmitInsertResultadosProcedimientos}>
          <div className="flex-auto overflow-y-auto relative p-1">
              <div className="flex">                
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Codigo
                  </label>
                  <input   
                    defaultValue={dataUnResultadoProcedimiento.RNQCod}   
                    disabled={true}              
                    name='codigo'
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  
                </div>
                
                
              </div>
              <div className="flex">
              
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Palabra Clave
                  </label>
                  <input
                    defaultValue={dataUnResultadoProcedimiento.RNQClv}
                    onChange={handleChangePalabraClave}
                    name='palabraClave'             
                    autoComplete="off"
                    type="text" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorPalabraClave}
                  </label>
                </div>
              </div>              
                <div className="flex">
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Tipo procedimiento
                  </label>                  
                  <div className="">
                  <select          
                    //onChange={handleOnchangeCaracteristica}  
                    defaultValue={dataUnResultadoProcedimiento.RNQTip}        
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='tipoProcedimiento'
                  >
                                         {/* <option value="">Todos</option> */}
                                        <option value="1">Imagenes diagnosticas</option>
                                        <option value="2">Laboratorios</option>
                                        <option value="3">Terapias</option>
                                        <option value="4">Procedimientos NO Qx</option>
                                        <option value="5">Procedimientos Qx</option>
                                        <option value="6">InterConsultas</option>
                                        <option value="7">Dietas</option>
                                        <option value="8">Recomendaciones</option>
                                        <option value="9">Certificados</option>
                                        <option value="10">Conclusiones</option>
                                        <option value="11">Contraindicaciones (CTC)</option>
                                        <option value="12">Justificación Uso (CTC)</option>
                                        <option value="13">Indicaciones de tratamiento (CTC)</option>
                                        <option value="14">Preparación de la Cirugía</option>
                                        <option value="15">Resultados Antecedentes Gineco</option>
                    
                  </select>
                </div>
                  
                </div>
                
              </div>
              <div className="flex p-2 text-left">
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={requiereManejoInterfase === "S"}
                        onChange={handleChangeManejoInterfase}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Maneja Interfase
                      </label>
                    </div>
                  </div>
                  <div className="w-1/2 flex">
                    <div className="topping">
                      <input
                        type="checkbox"
                        checked={requiereTipoTransfusional === "1"}
                        onChange={handleChangeTipoTransfusional}
                      />                          
                    </div>
                    <div className='ml-3'>
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                       Tipo transfusional
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex">                
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción
                  </label>
                  {/* <textarea
                  onChange={handleChangeDescripcion}
                  autoComplete="off" 
                  defaultValue={dataUnResultadoProcedimiento.RNQDes} 
                  name='descripcion'                    
                  className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="exampleFormControlTextarea1"
                  rows="2"
                  placeholder=""
                ></textarea> */}
                <ReactQuill
                  value={textDescripcion}
                  onChange={handleChangeDescripcion}
                  //name='descripcion' 
                  className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  theme="snow" // Usamos el tema "snow" de Quill
                  placeholder="Escribe aquí..."
                  modules={modules} // Configuramos la barra de herramientas
                  formats={formats}
                />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorDescripcion}
                  </label>
                </div>
                
                
              </div>
            
             
            

            
          </div>
        
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Aceptar
          </button>
        </div>
        </form>
        </div>
      </div>
    </div>    
    {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }
    
    
  </div>
  )
}

// Configuración de la barra de herramientas de React Quill
const modules = {
  toolbar: [
    [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
    [{size: []}],
    ['bold', 'italic', 'underline', 'strike'],
    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
    
    ['clean']
  ],
};

const formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 
  'list', 'bullet', 'indent',
  
];

export default ModalModificarUnResultadoProcedimiento